/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import template from "lodash/template";

window.BoostViewers = {
	maxcols: 0,
	maxrows: 0,
	maxthumbs: 0,
	queue: [],
	people: [],

	expanded: false,
	updating: null,
	updater: null,
	updatetime: 100,

	html: `\
<a href="/profile/<%= username %>?cf=userpane" class="match" id="sl_<%= username %>">
	<img src="<%= thumbnail %>" />
</a>\
`,

	init(params) {
		// shorties
		this.Model = BoostModel;
		this.Dom = BoostDom;
		this.Controller = BoostController;

		const object = this.Model.get("thumb_params");
		for (let key in object) {
			const value = object[key];
			this[key] = value;
		}

		this.template = template(this.html);

		// populate @people with the current suckers
		const thumbs = this.getVisibleThumbs();

		thumbs.toArray().forEach((thumb) => {
			thumb = $(thumb);
			const username = thumb.attr('id').replace('sl_', '');
			this.people.push(username);
		});
	},

	expand() {
		if (this.expanded) { return; }
		this.expanded = true;

		const { maxrows } = this;

		// reveal one row at a time
		this.maxthumbs = this.maxcols * maxrows;

		// add hidden users to the queue
		const thumbs = this.Dom.viewer_thumbs.find('.match.hid');
		const queue = [];

		thumbs.toArray().forEach((thumb) => {
			thumb = $(thumb);
			queue.push({
				username: thumb.attr('id').replace('sl_', '')
			});
		});

		this.queue = queue;

		// start an update chain
		this.update();
	},

	retract() {
		this.expanded = false;
		this.maxthumbs = this.maxcols * this.maxrows;

		// hide all extra thumbs
		const matches = this.Dom.viewer_thumbs.find('.match');
		let thumbcount = 0;

		matches.toArray().forEach((match) => {
			match = $(match);
			thumbcount++;

			if (thumbcount > this.maxthumbs) {
				match.addClass('hid');
			}
		});
	},

	getVisibleThumbs() {
		return this.Dom.viewer_thumbs.find('.match:not(.hid)');
	},

	updateQueue(queue) {
		const totalqueue = this.queue.concat(queue);
		queue = [];

		for (let person of Array.from(totalqueue)) {
			// ignore duplicates
			if (this.people.indexOf(person.username) > -1) {
				continue;
			}

			// ignore people already on the board
			if ($(`#sl_${person.username}`).length && !$(`#sl_${person.username}`).hasClass('hid')) {
				continue;
			}

			this.people.push(person.username);
			queue.push(person);
		}

		this.queue = queue;

		if (!this.updating) {
			this.update();
		}
	},

	update() {
		clearTimeout(this.updater);

		if (!this.queue.length) {
			this.updating = false;
			return;
		}

		this.updating = true;

		let person = this.queue[0];
		this.queue.splice(0, 1);
		const personel = $(`#sl_${person.username}`);

		// if they're already here...
		if (personel.length) {
			if (personel.hasClass('hid')) {
				// unhide them if they're hidden
				personel.removeClass('hid').addClass('new');
			} else {
				// move to the next one if they're unhidden already
				this.update();
				return;
			}

		// otherwise, make a new man for them
		} else {
			let html = this.template(person);
			html = $(html);

			const thumbs = this.Dom.viewer_thumbs.find('.match').length;
			const thumbsunhid = this.getVisibleThumbs().length;

			// if there are hidden, replace the first
			if (thumbs !== thumbsunhid) {
				person = this.Dom.viewer_thumbs.find('.match.hid').eq(0);
				person.replaceWith(html);

			// if we're full, drop the first row and plop onto the end
			} else if (thumbsunhid === this.maxthumbs) {
				this.Dom.viewer_thumbs.find('.match').slice(0, this.maxcols).remove();
				this.Dom.viewer_thumbs.append(html);

			// otherwise, plop onto end
			} else {
				this.Dom.viewer_thumbs.append(html);
			}

			html.addClass('new');
		}

		// update time based on whether it's full or not
		const { updatetime } = this;

		this.updater = setTimeout(this.update.bind(this), updatetime);
	},

	stop() {
		this.queue = [];
		this.updating = false;
		this.retract();
		clearTimeout(this.updater);
	},
};



// WEBPACK FOOTER //
// ./src/legacy/boosts/controller_viewers.js